/**
 * UserId do processo de sanitização automática para o ambiente atual.
 * Defina `VITE_SANITIZATION_USER_ID` em `.env.production`, `.env.staging`, etc.
 * Sem valor válido, `isSanitizationLog` não reconhece nenhum log como sanitização.
 *
 * Não há fallback para outro ambiente: um build sem env configurada não deve
 * assumir silenciosamente o ID de produção.
 */
const raw = import.meta.env.VITE_SANITIZATION_USER_ID as string | undefined;
const trimmed = typeof raw === "string" ? raw.trim() : "";

if (!trimmed) {
  console.warn(
    "VITE_SANITIZATION_USER_ID não configurada — sanitização não será identificada nos logs",
  );
}

export const SANITIZATION_USER_ID: string | null = trimmed || null;

export const isSanitizationLog = (log: {
  executed_by_user_id?: string | null;
}): boolean =>
  SANITIZATION_USER_ID != null &&
  log.executed_by_user_id === SANITIZATION_USER_ID;
